// IMPORT PACKAGE REFERENCES
import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getAllEquipment } from '../state/actions/EquipmentActions';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, FormGroup, FormFeedback, Label, InputGroupAddon, InputGroup } from 'reactstrap';

//COMPONENT

class EquipmentSpecsModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            equipmentItem: {},
            isValid: true,
            isWeightValid: true,
            isHeightValid: true,
            isDepthValid: true,
            isWidthValid: true,
            isVolumeValid: true,
            isNameValid: true,
            width: 0,
            height: 0,
            depth: 0,
            volume: 0,
            weight: 0,
            name: ''
        };

        this.updateDetails = this.updateDetails.bind(this);

        this.dismissModal = this.dismissModal.bind(this);
        this.weightChange = this.weightChange.bind(this);
        this.heightChange = this.heightChange.bind(this);
        this.widthChange = this.widthChange.bind(this);
        this.depthChange = this.depthChange.bind(this);
        this.volumeChange = this.volumeChange.bind(this);
        this.nameChange = this.nameChange.bind(this);
        this.saveDetails = this.saveDetails.bind(this);

        this.validate = this.validate.bind(this);

    }

    componentDidMount(){
        this.setState({equipmentItem: this.props.equipmentItem});
        this.updateDetails();
        
    }

    componentDidUpdate(prevProps) {
        if (this.props.equipmentItem != prevProps.equipmentItem) {
            this.setState({ equipmentItem: this.props.equipmentItem });
            this.updateDetails();
        }
    }

    updateDetails(){
        if(this.props.equipmentItem.weight != undefined) {
            this.setState({
                weight: this.props.equipmentItem.weight
            });
        }

        if(this.props.equipmentItem.volume != undefined) {
            this.setState({
                volume: this.props.equipmentItem.volume
            });
        }

        if(this.props.equipmentItem.dimensions != undefined) {
            this.setState({
                width: this.props.equipmentItem.dimensions.width,
                height: this.props.equipmentItem.dimensions.height,
                depth: this.props.equipmentItem.dimensions.depth
            });
        }

        this.setState({
            name: this.props.equipmentItem.name
        });
    }

    dismissModal(){
        this.props.toggleModal();
    }

    weightChange(e){
        if(!isNaN(Number(e.target.value))) {
            this.setState({weight: e.target.value});
        }
    }

    heightChange(e){
        if(!isNaN(Number(e.target.value))) {
            this.setState({height: e.target.value});
        }
    }

    widthChange(e){
        if(!isNaN(Number(e.target.value))) {
            this.setState({width: e.target.value});
        }
    }

    depthChange(e){
        if(!isNaN(Number(e.target.value))) {
            this.setState({depth: e.target.value});
        }
    }

    volumeChange(e){
        if(!isNaN(Number(e.target.value))) {
            this.setState({volume: e.target.value});
        }
    }

    nameChange(e) {
        this.setState({name: e.target.value});
    }

    saveDetails(){
        if (this.validate()) {
            let equipmentItem = JSON.parse(JSON.stringify(this.state.equipmentItem));

            equipmentItem.weight = Number(this.state.weight);
            equipmentItem.dimensions.width = Number(this.state.width);
            equipmentItem.dimensions.height = Number(this.state.height);
            equipmentItem.dimensions.depth = Number(this.state.depth);
            equipmentItem.volume = Number(this.state.volume);
            equipmentItem.name = this.state.name;
    
            this.props.updateEquipment(equipmentItem);
    
            this.props.toggleModal();
        }
    }

    validate(){
        this.setState({
            isWeightValid: this.state.weight != '',
            isHeightValid: this.state.height != '',
            isDepthValid: this.state.depth != '',
            isWidthValid: this.state.width != '',
            isVolumeValid: this.state.volume != '',
            isNameValid: this.state.name != ''
        });

        return this.state.weight != '' && this.state.height != '' && this.state.depth != '' && this.state.width != '' && this.state.volume != '' && this.state.name != '';
    }

    render() {
        return (
            <Fragment>
                <Modal isOpen={this.props.isOpen} toggle={this.toggle} >
                    <ModalHeader toggle={this.toggle}>Equipment Details</ModalHeader>
                    <ModalBody>

                        <FormGroup>
                            <Label for="name">Name</Label>
                            <InputGroup>
                                <Input invalid={!this.state.isNameValid} type="text" name="name" id="name" placeholder="Name" onChange={this.nameChange} value={this.state.name} />
                                <FormFeedback>Name cannot be empty</FormFeedback>
                            </InputGroup>
                        </FormGroup>

                        <FormGroup>
                            <Label for="width">Width</Label>
                            <InputGroup>
                                <Input invalid={!this.state.isWidthValid} type="text" name="width" id="width" placeholder="Width" onChange={this.widthChange} value={this.state.width} />
                                <InputGroupAddon addonType="append">metres</InputGroupAddon>
                                <FormFeedback>Please enter a valid weight</FormFeedback>
                            </InputGroup>
                        </FormGroup>

                        <FormGroup>
                            <Label for="height">Height</Label>
                            <InputGroup>
                                <Input invalid={!this.state.isHeightValid} type="text" name="height" id="height" placeholder="Height" onChange={this.heightChange} value={this.state.height} />
                                <InputGroupAddon addonType="append">metres</InputGroupAddon>
                                <FormFeedback>Please enter a valid weight</FormFeedback>
                            </InputGroup>
                        </FormGroup>

                        <FormGroup>
                            <Label for="depth">Depth</Label>
                            <InputGroup>
                                <Input invalid={!this.state.isDepthValid} type="text" name="depth" id="depth" placeholder="Depth" onChange={this.depthChange} value={this.state.depth} />
                                <InputGroupAddon addonType="append">metres</InputGroupAddon>
                                <FormFeedback>Please enter a valid weight</FormFeedback>
                            </InputGroup>
                        </FormGroup>

                        <FormGroup>
                            <Label for="volume">Volume</Label>
                            <InputGroup>
                                <Input invalid={!this.state.isVolumeValid} type="text" name="volume" id="volume" placeholder="volume" onChange={this.volumeChange} value={this.state.volume} />
                                <InputGroupAddon addonType="append">litres</InputGroupAddon>
                                <FormFeedback>Please enter a valid weight</FormFeedback>
                            </InputGroup>
                        </FormGroup>

                        <FormGroup>
                            <Label for="weight">Weight</Label>
                            <InputGroup>
                                <Input invalid={!this.state.isWeightValid} type="text" name="weight" id="weight" placeholder="Weight" onChange={this.weightChange} value={this.state.weight} />
                                <InputGroupAddon addonType="append">kg</InputGroupAddon>
                                <FormFeedback>Please enter a valid weight</FormFeedback>
                            </InputGroup>
                        </FormGroup>
                    </ModalBody>

                    <ModalFooter>
                        <Button className="button" color="secondary" onClick={this.dismissModal}>Cancel</Button>
                        <Button className="button" color="primary" onClick={this.saveDetails}>Update</Button>{' '}
                    </ModalFooter>
                </Modal>
            </Fragment>
        );
    }
}

EquipmentSpecsModal.propTypes = {
    history: PropTypes.object.isRequired,
    isOpen: PropTypes.bool.isRequired,
    toggleModal: PropTypes.func.isRequired,
    equipmentItem: PropTypes.object.isRequired,
    updateEquipment: PropTypes.func.isRequired
};

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    const { allEquipment, fetchingAllEquipment, fetchedAllEquipment, failedAllEquipment} = state.equipmentReducer;
    return { allEquipment, fetchingAllEquipment, fetchedAllEquipment, failedAllEquipment };
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({ getAllEquipment }, dispatch)
);

const hoc = withRouter(connect(mapStateToProps, mapDispatchToProps)(EquipmentSpecsModal));

// EXPORT COMPONENT
export { hoc as EquipmentSpecsModal };


// WEBPACK FOOTER //
// ./src/components/modals/EquipmentSpecsModal.js